import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-experience-dropdown',
  templateUrl: './experience-dropdown.component.html',
  styleUrls: ['./experience-dropdown.component.scss']
})
export class ExperienceDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
